export default __webpack_public_path__ + "static/media/dislike.9d4365c4.svg";